export enum UserStateEnum {
  Active = 1,
  Inactive = 2,
}
